module.exports = __webpack_public_path__ + "static/Dispatcher_panel-05379e7a52492ebb45ad26c6ecbc2717.png";